import React, { useEffect, useRef }                   from 'react';
import NotificationService                            from 'services/notification.service';
import AuthService                                    from 'services/auth.service';
import NotificationFilter                             from './NotificationFilter';
import { Table }                                      from 'react-bootstrap';
import IconBell                                       from 'assets/icons/Bell Icon.svg';
import IconAppointment                                from 'assets/icons/Appointment.svg';
import IconMessage                                    from 'assets/icons/Message.svg';
import IconPen                                        from 'assets/icons/Pen.svg';
import moment                                         from 'moment';
import Spinner                                        from 'react-bootstrap/Spinner';
import { useSelector, useDispatch }                   from "react-redux";
import { fetchNotifications, notificationsSelector }  from 'app/notificationSlice';

export function Notification() {
  const dispatch = useDispatch();
  const sources = {
    Appointment: IconAppointment,
    ChatMessageNotification: IconMessage,
    Referral: IconPen
  }
  const types = {
    teleconsult__new_chat_session: IconMessage,
    chat: IconMessage
  }
  const isCancelled = useRef(false);
  const isCancelledRead = useRef(false);
  const { notifications, loading, hasErrors } = useSelector(notificationsSelector)
  const socketInfo = AuthService.getSocketInfo();

  useEffect(() => {
    dispatch(fetchNotifications(1))
    return () => {
      isCancelled.current = true;
    };
  }, [dispatch]); // eslint-disable-line

  useEffect(() => {
    if(notifications.length !== 0){
      updateReads();
    }
     return () => {
      isCancelledRead.current = true;
     };
   }, [notifications]); // eslint-disable-line

  const updateReads = () => {
    let unreads = [];
    unreads = notifications.filter(n => {
      return !n.read;
    }).map(n => {
      return n.id;
    });

    if(unreads.length > 0){
      let params = {
        notification_ids: unreads
      }
  
      NotificationService.updateRead(params).then(
        (data) => {
          // read updated
        },
        (error) => {
          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace('/eb/login');
          }
        }
      );
    }
  }

  const getIcon = (n) => {
    let icon = IconBell;
    let payload = n.payload;

    if(sources[n.source]){
      icon = sources[n.source];
    }else if(payload && types[payload.type]){
      icon = types[payload.type]
    }
    return icon;
  }

  const getMessage = (n) => {
    let message = '-';
    let payload = n.payload;
    if(n.source === 'Referral'){
      message = `${payload.doctor_name} referred a patient to you.`;
    }else if(n.source === 'Appointment' && payload.appointment_status){
      if(payload.appointment_type === 'virtual' && !socketInfo.isAssistant){
        var appt_status = payload.appointment_status.toLowerCase().includes("rescheduled") ? 'Rescheduled' : 'New'

        var description = payload.appointment_status.toLowerCase().includes("rescheduled") ? 'Your video session has been rescheduled' : 'You have an upcoming video session'
        message = `${appt_status} Video Session - ${description}.`
      }else{
        var appt_status = payload.appointment_status.toLowerCase().includes("cancelled") ? 'cancelled' : 'created'
        message = `${payload.appointment_status} - ${payload.user} ${appt_status} an appointment.`
      }
      if(payload.cancelled){
        message = `<span class="text-danger">[CANCELLED]</span> ${message}`;
      }
    } else if (n.source === "MealComment" && n.payload.meal_id) {
      const mealUrl = `/eb/meals?meal_id=${n.payload.meal_id}`;
      return (
        <div className="message">
          <a
            href={mealUrl}
            style={{ textDecoration: "underline", color: "#dc3545" }}
          >
            {n.message}
          </a>
        </div>
      );
    } else {
      message = n.message;
    }

    return message;
  }

  const getMessageDetails = (n) => {
    if(n.source === 'Appointment'){
      let payload = n.payload;
      return (
        <>
          <div className="message" dangerouslySetInnerHTML={{ __html: getMessage(n)}} />
          <div className="row mt-1">
            <div className="col-12 col-lg-4">Date/Time : <b>{moment.unix(payload.appointment_time).format('DD MMM YYYY, HH:mm A')}</b></div>
            {payload.appointment_type === 'physical' && <div className="col-12 col-lg-4">Location : <b>{payload.location}</b></div>}
          </div>
        </>
      );
    } else {
      return <div className="message">{getMessage(n)}</div>;
    }
  }

  const Notifications = () => {
    if (loading) return <tr className="loader"><td className="border-bottom-0"><Spinner animation="border" className="spinner"/></td></tr>;
    if (hasErrors) return <tr className="loader"><td className="border-bottom-0">Cannot display notifications.</td></tr>;
    if (notifications.length === 0) return <tr className="loader"><td className="border-bottom-0">No Notification</td></tr>;

    return notifications.map((n,i) => {
      return (
        <tr key={`notification-row-${i}`} className={`w-100 ${(!n.read && 'new')}`}>
          <td className="icon position-relative"><img src={getIcon(n)} alt="notification-icon"/></td>
          <td className="details">
            <div className="datetime">{moment(n.created_at).format('DD MMM YYYY, HH:mm A')}</div>
            {getMessageDetails(n)}
          </td>
        </tr>
      );
    })
  }

  return (
    <div id="main-content-target" className="notifications-page">
      <h1 className="header-title">Notifications</h1>
      <div>
        <NotificationFilter />
        <Table className="notifications-table">
          <tbody>
            <Notifications />
          </tbody>
        </Table>
      </div>
    </div>
  );
}

export default Notification;